import { render, staticRenderFns } from "./homepageMoreVod.vue?vue&type=template&id=bfe75b2c&scoped=true&"
import script from "./homepageMoreVod.vue?vue&type=script&lang=js&"
export * from "./homepageMoreVod.vue?vue&type=script&lang=js&"
import style0 from "./homepageMoreVod.vue?vue&type=style&index=0&lang=css&"
import style1 from "./homepageMoreVod.vue?vue&type=style&index=1&id=bfe75b2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe75b2c",
  null
  
)

export default component.exports